// extracted by mini-css-extract-plugin
export var activeDot = "_3j-c";
export var buttonContainer = "_3j-9";
export var channelButton = "_3j-a";
export var clickable = "_3j-d";
export var content = "_3j-0";
export var contentFull = "_3j-2";
export var contentThird = "_3j-1";
export var contentWrapper = "_3j-7";
export var description = "_3j-5";
export var heightShort = "_3j-f";
export var image = "_3j-3";
export var imageContainer = "_3j-4";
export var selectButton = "_3j-e";
export var spinnerContainer = "_3j-b";
export var titleContent = "_3j-8";
export var titleWrapper = "_3j-6";